import type { LayoutY } from '#packages/layout';
import type { ComponentWithLayout } from './types';

export const GET_LAYOUT_OPTIONS: LayoutY.GetLayoutOptions<ComponentWithLayout> =
  {
    getLayout: (component) => component.layout,
  };
